function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("path", {
  d: "m4.895 4.891132h20.21v20.21h-20.21z",
  fill: "currentColor",
  fillRule: "nonzero",
  stroke: "#071920",
  transform: "matrix(.70710678 .70710678 -.70710678 .70710678 14.997265 -6.214336)"
}), React.createElement("g", {
  transform: "translate(5 6)"
}, React.createElement("path", {
  className: "icon",
  d: "m2.39 12.13 1.19.79c.66.43 1.31.87 2 1.29.33919803.2007171.76080197.2007171 1.1 0l11.1-5.64c.7566301-.38936076 1.0543607-1.31836989.665-2.07499998-.3893608-.7566301-1.3183699-1.05436074-2.075-.66500002l-4 2c-.1512064.07501938-.3287936.07501938-.48 0l-7.48-2.3h-.12-.12-.09l-.82.42c-.11498785.07086536-.18644551.19497604-.19.33-.00316897.11646465.04870323.22761937.14.3h.05l4.35 2.39h.06c.20050002.10608042.3270644.31318577.33.54.00055895.22768926-.12178201.43796278-.32.55h-.05l-2.1 1.06c-.10638427.0398864-.22361573.0398864-.33 0-.73-.21-2.25-.68-2.25-.68-.08887013-.0201681-.18112987-.0201681-.27 0-.10678329-.0009078-.21135037.0304623-.3.09l-1.12.6",
  stroke: "#071920",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), React.createElement("path", {
  d: "m0 0h20v20h-20z"
})));

var SvgPlane = function SvgPlane(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 30 30",
    height: 30,
    width: 30,
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgPlane, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/plane.efc67142.svg";
export { ForwardRef as ReactComponent };